import createApiMiddlewareReducer from '../utils/create-api-middleware-reducer'
import {
  REQUEST_SOURCE_VERSIONS,
  REQUEST_SOURCE_VERSIONS_ERROR,
  RECEIVE_SOURCE_VERSIONS
} from 'actions'

const versionsReducer = createApiMiddlewareReducer({
  request: REQUEST_SOURCE_VERSIONS,
  failure: REQUEST_SOURCE_VERSIONS_ERROR,
  receive: RECEIVE_SOURCE_VERSIONS
})

export default (state = {}, action) => {
  const { type, payload } = action
  let key = null

  switch (type) {
    case REQUEST_SOURCE_VERSIONS:
    case REQUEST_SOURCE_VERSIONS_ERROR:
    case RECEIVE_SOURCE_VERSIONS:
      key = `${payload.workspaceSlug}-${payload.sourceSettingSlug}`
      return {
        ...state,
        [key]: versionsReducer(state[key], action)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/source-upgrades/versions.js